module.exports = __webpack_public_path__ + "img/12.dadf04fc.jpg";